<template>
  <div>
    <ul>
      <li>Legacy ID: <sc-text :field="fields.postID" /></li>
      <li>Legacy URL: <sc-text :field="fields.legacyUrl" /></li>
    </ul>
    <h3>Taxonomies</h3>
    <ul>
      <li>
        Tags:
        <taxonomy-items v-bind:items="fields.tags" />
      </li>
      <li>
        Technologies:
        <taxonomy-items v-bind:items="fields.technologies" />
      </li>
      <li>
        Controls:
        <taxonomy-items v-bind:items="fields.controls" />
      </li>
      <li>
        Owners:
        <taxonomy-items v-bind:items="fields.owners" />
      </li>
      <li v-if="fields.categories">
        Categories:
        <taxonomy-items v-bind:items="fields.categories" />
      </li>
    </ul>
  </div>
</template>

<script>
import { Text } from '@sitecore-jss/sitecore-jss-vue';
import TaxonomyItems from './CIS-TaxonomyItems.vue';

export default {
  name: 'CIS-ResourceTaxonomies',
  props: {
    fields: {
      type: Object
    }
  },
  components: {
    ScText: Text,
    TaxonomyItems: TaxonomyItems
  }
};
</script>
